import React from 'react';
import { Box, Card, CardActionArea, Container, Paper, Stack, Typography } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';
import { useCaregiverPortal } from '../../context/CaregiverPortalContext';

// Caregiver actions shown on the hub; add new caregiver pages here.
const HUB_ACTIONS = [
  { to: '/availability', icon: EventAvailableIcon, titleKey: 'hub.availability.title', descriptionKey: 'hub.availability.description' },
  { to: '/caregiverform', icon: AssignmentIcon, titleKey: 'hub.caregiverForm.title', descriptionKey: 'hub.caregiverForm.description' },
] as const;

/** /caregivers: home for caregivers who have submitted the portal form; styled like the /start card. */
const CaregiverHub: React.FC = () => {
  const { t } = useTranslation();
  const { firstName } = useCaregiverPortal();

  return (
    <Container maxWidth="sm" sx={{ mt: 5, mb: 4 }}>
      <Paper elevation={3} sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#fff', borderRadius: '10px' }}>
        <Box textAlign="center" mb={3}>
          <img
            src="/images/logo/evo-logo.png"
            alt="Faith Logo"
            style={{ maxWidth: '40%', height: 'auto', marginTop: '12px', marginBottom: '16px' }}
          />
          <Typography variant="h5">
            {firstName ? t('hub.welcomeName', { name: firstName }) : t('hub.welcome')}
          </Typography>
          <Typography color="text.secondary" sx={{ mt: 0.5 }}>
            {t('hub.intro')}
          </Typography>
        </Box>

        <Stack spacing={1.5}>
          {HUB_ACTIONS.map(({ to, icon: Icon, titleKey, descriptionKey }) => (
            <Card key={to} variant="outlined" sx={{ borderRadius: '10px' }}>
              <CardActionArea
                component={NavLink}
                to={to}
                sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, justifyContent: 'flex-start' }}
              >
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    bgcolor: 'rgba(137, 0, 225, 0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <Icon sx={{ color: '#8900e1' }} />
                </Box>
                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                  <Typography sx={{ fontWeight: 600 }}>{t(titleKey)}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {t(descriptionKey)}
                  </Typography>
                </Box>
                <ChevronRightIcon color="action" />
              </CardActionArea>
            </Card>
          ))}
        </Stack>
      </Paper>
    </Container>
  );
};

export default CaregiverHub;
